import { render, staticRenderFns } from "./ImportCardCognito.vue?vue&type=template&id=1aa91d16&"
import script from "./ImportCardCognito.vue?vue&type=script&lang=js&"
export * from "./ImportCardCognito.vue?vue&type=script&lang=js&"
import style0 from "./ImportCardCognito.vue?vue&type=style&index=0&id=1aa91d16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports